<template>
  <v-app>
    <v-navigation-drawer
      v-if="auth"
      v-model="drawer"
      app
      style="z-index: 200"
      mobile-break-point="1900"
    >
      <v-row justify="center">
        <v-container>
          <v-img
            src="./assets/linkedin_banner_image_1.png"
            v-if="userLogo == ''"
          />

          <v-img :src="userLogo" v-else contain />
        </v-container>
      </v-row>
      <v-list dense nav>
        <template
          v-for="item in $store.getters.userConfig.isSupplier
            ? supplierMenu
            : mainMenu"
        >
          <v-list-group
            v-if="item.items && hasAccessTo(item.title, 'visible')"
            v-model="item.active"
            :key="item.title"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title
                  ><span :title="item.title">{{
                    item.title
                  }}</span></v-list-item-title
                >
              </v-list-item>
            </template>

            <template v-for="subItem in item.items">
              <v-list-group
                v-if="subItem.items && hasAccessTo(item.title, subItem.title)"
                v-model="subItem.active"
                :key="subItem.title"
                sub-group
                no-action
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-title
                      ><span :title="subItem.title">{{
                        subItem.title
                      }}</span></v-list-item-title
                    >
                    <v-list-item-action>
                      <v-icon>{{ subItem.action }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <template v-for="subSubItem in subItem.items">
                  <v-list-item
                    v-if="hasAccessTo(subItem.title, subSubItem.title)"
                    @click="navigateTo(subSubItem.link)"
                  >
                    <v-list-item-title :key="subSubItem.title"
                      ><span :title="subSubItem.title">{{
                        subSubItem.title
                      }}</span></v-list-item-title
                    >
                  </v-list-item>
                </template>
              </v-list-group>
              <v-list-item
                v-else-if="hasAccessTo(item.title, subItem.title)"
                :key="subItem.title"
                @click="navigateTo(subItem.link)"
              >
                <v-list-item-title
                  ><span :title="subItem.title">{{
                    subItem.title
                  }}</span></v-list-item-title
                >

                <v-btn icon @click.stop="newTab(subItem.link)">
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item
            v-else-if="hasAccessTo(item.title, 'visible')"
            @click="navigateTo(item.link)"
            :key="item.title"
          >
            <v-list-item-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-item-action>
            <v-list-item-title
              ><span :title="item.title">{{
                item.title
              }}</span></v-list-item-title
            >

            <v-btn icon @click.stop="newTab(item.link)">
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-row justify="center">
          <v-switch
            class="ml-2"
            v-model="outlined"
            label="Outlined"
            @change="onOutlinedChange"
            hide-details
            small
          ></v-switch>
        </v-row>
        <v-row justify="center" v-if="false">
          <v-switch
            class="ml-2"
            v-model="fixedMenu"
            label="Fixed Menu"
            small
          ></v-switch>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
      dense
      class="app-bar"
      v-if="auth && fixedMenu"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        {{ appToolbarInfo }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text v-if="false">Link One</v-btn>
      </v-toolbar-items>

      <span>{{ version }}</span>

      <v-btn icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content class="bg">
      <v-container
        :fluid="!auth || $vuetify.breakpoint.lgAndDown"
        fill-height
        align-start
        :class="{ 'pa-0': !auth }"
      >
        <router-view></router-view>
      </v-container>
    </v-content>
    <app-snackbar></app-snackbar>
    <v-footer v-if="false" color="indigo" app>
      <span class="white--text">&copy; 2018</span>
    </v-footer>
    <div id="addons"></div>
  </v-app>
</template>

<script>
import AppSnackbar from "./components/gt/shared/AppSnackbar";
import { GT_APP_NAME } from "./constants/settings";
import { apolloClient } from "./constants/apollo-provider";

const randomize = require("randomatic");
export default {
  name: "App",
  components: { AppSnackbar },
  created() {
    //console.log('app created: ', this.$route);
    //this.$store.dispatch('checkAuth');
  },
  data() {
    return {
      outlined: this.$store.getters.localSettings("outlinedInputs", true),
      fixedMenu: true,
      miniVariant: false,
      darkMode: false,
      version: this.$store.getters.appVersion,
      drawer: null,
      inactivityTimer: null,
      inactivityTime: 3000,
      supplierMenu: [{ title: "Home", link: "/home", action: "mdi-home" }],
      mainMenu: [
        { title: "Home", link: "/home", action: "mdi-home" },
        {
          title: "Itineraries",
          link: "/itineraries",
          action: "mdi-format-list-bulleted-square",
        },
        {
          title: "Templates",
          action: "mdi-ballot",
          items: [
            { title: "Templates List", link: "/templates" },
            { title: "Template Types", link: "/template-types" },
          ],
        },
        {
          title: "Group Templates",
          action: "mdi-ballot",
          link: "/group-templates",
        },
        {
          title: "Open Groups",
          action: "mdi-account-group",
          link: "/open-groups",
        },
        {
          action: "mdi-hotel",
          title: "Suppliers",
          items: [
            { title: "Accommodation", link: "/suppliers/accommodation" },
            { title: "Activity", link: "/suppliers/activity" },
            { title: "Transport", link: "/suppliers/transport" },
            { title: "Travel", link: "/suppliers/travel" },
            { title: "Package", link: "/suppliers/package" },
            { title: "Other", link: "/suppliers/other" },
            {
              title: "Head Offices",
              link: "/head-offices",
            },
          ],
        },
        {
          title: "Agents & Groups",
          action: "mdi-account-tie",
          items: [
            { title: "Agents", link: "/agents" },
            { title: "Agent Groups", link: "/agent-groups" },
            { title: "Agent Types", link: "/agent-types" },
          ],
        },
        //{ action: "mdi-account", title: "Clients", link: "/clients" },
        {
          title: "Clients",
          action: "mdi-account-tie",
          items: [
            { title: "Clients List", link: "/clients" },
            { title: "Client Titles", link: "/client-titles" },
            { title: "Client Types", link: "/client-types" },
            { title: "Client Statuses", link: "/client-statuses" },
          ],
        },
        {
          action: "mdi-finance",
          title: "Finances",
          items: [
            { title: "Sales Invoices", link: "/sales-invoices" },
            { title: "Receipts & Refunds", link: "/receipts" },
            { title: "Purchase Invoices", link: "/purchase-invoices" },

            { title: "Sage PI Approvals", link: "/pi-approvals" },
            {
              title: "PI Payments",
              link: "/purchase-invoice-payments",
            },
          ],
        },
        { title: "Reports", link: "/reports", action: "mdi-file-chart" },
        {
          action: "mdi-shape-rectangle-plus",
          title: "Plugins",
          items: [
            { title: "Access Module", link: "/user-access-settings" },
            { title: "Allocations", link: "/allocations-plugin" },
            {
              title: "Available Access Settings",
              link: "/available-access-settings",
            },
            { title: "Circuit Discounts", link: "/circuit-discounts" },
            { title: "Commissions", link: "/commissions" },
            {
              title: "Data Importer",
              link: "/rates-importer",
            },
            { title: "Flights Management", link: "/flights-management" },
            {
              title: "GT Template Importer",
              link: "/gt-importer",
            },
            { title: "Histories List", link: "/history-list" },
            { title: "Markups", link: "/markups" },
            { title: "Supplier Contents", link: "/supplier-contents" },
            { title: "Task Tracker", link: "/task-tracker" },
            { title: "Third Party Setup", link: "/third-party-setups" },
            { title: "External Forms", link: "/external-forms" },
            { title: "Process Logs", link: "/process-logs" },
          ],
        },

        {
          action: "mdi-tune",
          title: "Admin",
          items: [
            {
              title: "Destinations & Pickup Points",
              action: "mdi-earth",
              items: [
                {
                  title: "Destinations",
                  link: "/admin/all-destinations",
                },

                {
                  title: "Pick Up/Drop Off",
                  link: "/admin/pickups-list",
                },
                {
                  title: "Routes",
                  link: "/admin/routes",
                },
              ],
            },

            {
              title: "Service Types",
              action: "mdi-golf",
              items: [
                {
                  title: "Rooms",
                  link: "/admin/rooms",
                },
                {
                  title: "Activities",
                  link: "/admin/activity-types",
                },
                {
                  title: "Transport",
                  link: "/admin/transport-types",
                },
                {
                  title: "Travel",
                  link: "/admin/travel-types",
                },
                {
                  title: "Other",
                  link: "/admin/other-types",
                },
                {
                  title: "Extras",
                  link: "/admin/extra-types",
                },
                {
                  title: "Accommodation",
                  link: "/admin/accommodation-types",
                },
                {
                  /* http://tracker.globetrack.ie/issues/5525 - Add Package as an available service type list. */
                  title: "Package",
                  link: "/admin/package-types",
                },
                {
                  title: "Board Basis",
                  link: "/admin/board-basis-types",
                },
                {
                  title: "Star Rating",
                  link: "/admin/star-rating",
                },
              ],
            },
            {
              title: `${
                this.$store.getters.isCPS
                  ? "Departments & Itinerary Destinations"
                  : "Departments & Brands"
              }`,
              action: "mdi-domain",
              items: [
                {
                  title: "Departments",
                  link: "/admin/departments",
                },
                {
                  title: `${
                    this.$store.getters.isCPS
                      ? "Itinerary Destinations"
                      : "Brands"
                  }`,
                  link: "/admin/brands",
                },
                {
                  title: `${
                    this.$store.getters.isCPS
                      ? "Operations Teams"
                      : "Lead Sources"
                  }`,
                  link: "/admin/lead-sources",
                },
              ],
            },
            {
              title: "Rate Types",
              link: "/admin/rate-types",
            },
            {
              title: "Export Logs",
              link: "/admin/export-logs",
            },
            {
              title: "Accounts",
              action: "mdi-domain",
              items: [
                {
                  title: "Business Models",
                  link: "/admin/business-models",
                },
                {
                  title: "Currencies",
                  link: "/admin/currencies",
                },
                {
                  title: "Currency Exchange Rates",
                  link: "/admin/exchange-rates",
                },
                {
                  title: "Internal Statuses",
                  link: "/admin/internal-statuses",
                },
                {
                  title: "Nominal Codes",
                  link: "/admin/nominal-codes",
                },
                {
                  title: "Charges Types",
                  link: "/admin/charges-types",
                },
                {
                  title: "Mandatory Charges",
                  link: "/admin/mandatory-charges",
                },
                {
                  title: "Payment Methods",
                  link: "/admin/payment-methods",
                },
                {
                  title: "Payment Types",
                  link: "/admin/payment-types",
                },
                {
                  title: "Taxes",
                  link: "/admin/taxes",
                },
              ],
            },
            {
              title: "Languages & Translations",
              action: "mdi-web",
              items: [
                {
                  title: "Languages",
                  link: "/admin/languages",
                },
                {
                  title: "Translations",
                  link: "/admin/translations",
                },
              ],
            },
            {
              title: "Contents & Documents",
              action: "mdi-content-duplicate",
              items: [
                {
                  title: "Itinerary Documents",
                  link: "/admin/itinerary-documents",
                },
                {
                  title: "Documents Content",
                  link: "/admin/documents-contents",
                },
                {
                  title: "Email Types",
                  link: "/admin/email-types",
                },
                {
                  title: "Emails Contents",
                  link: "/admin/emails-contents",
                },
                {
                  title: "Other Contents",
                  link: "/admin/other-contents",
                },
                {
                  title: "Itinerary Contents",
                  link: "/admin/itinerary-contents",
                },
                {
                  title: "Supplier Note Types",
                  link: "/admin/supplier-iti-note-types",
                },
                {
                  title: "Custom Data Types",
                  link: "/admin/custom-data-types",
                },
              ],
            },
            {
              title: "Task Settings",
              action: "mdi-ballot-outline",
              items: [
                {
                  title: "Task Statuses",
                  link: "/admin/task-statuses",
                },
                {
                  title: "Task Priorities",
                  link: "/admin/task-priorities",
                },
              ],
            },
            {
              title: "Tenant Setup",
              link: "/admin/tenant-setup",
            },
            /*{
              title: "Owner Controls",
              link: "/admin/owner-controls",
            },*/
          ],
        },
      ],
    };
  },
  computed: {
    appToolbarInfo() {
      return this.$store.getters.appToolbarInfo != ""
        ? `${this.$store.getters.appToolbarInfo}`
        : this.appName;
    },
    appName() {
      let defaultLabel = GT_APP_NAME;
      const { name, ownerName, agentCompanyCode } =
        this.$store.getters.userConfig;
      const companycodeInfo = agentCompanyCode ? `(${agentCompanyCode})` : "";
      defaultLabel = `${ownerName} ${companycodeInfo}, ${name}`;
      return defaultLabel;
    },
    auth() {
      return this.$store.getters.isAuthenticated;
    },
    userLogo() {
      return this.$store.getters.userConfig &&
        this.$store.getters.userConfig.logo
        ? this.$store.getters.userConfig.logo
        : "";
    },
    isPinky() {
      return window.location.hostname.indexOf("pinkelephantinternational") > -1;
    },
  },

  // watch: {
  //   $route(to, from) {
  //     console.log("route changed", this.$route);
  //   },
  // },

  methods: {
    logoutDueInactivity() {
      this.$store.dispatch("logout");
      alert("YOUR SESSION EXPIRED. PLEASE LOG IN TO CONTINUE");
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(
        this.logoutDueInactivity,
        this.$store.getters.inactivityTime
      );
    },

    onOutlinedChange(event) {
      this.$store.dispatch("updateLocalSettings", {
        outlinedInputs: event,
      });
    },
    onThemeChange($event) {
      this.$vuetify.theme.dark = $event;
    },
    logout() {
      if (confirm("Are you sure you want logout?")) {
        this.$store.dispatch("logout");
      }
    },
    newTab(path) {
      const routeData = this.$router.resolve({ path: path });
      window.open(routeData.href, "_blank");
    },
    navigateTo(path) {
      this.$router.push({ path });
    },
    hasAccessTo(title, actionName) {
      if (actionName == "Tenant Setup") {
        //true for user sean
        return this.$store.getters.userConfig.username == "sean";
      }
      if (actionName == "Available Access Settings") {
        return this.$store.getters.userConfig.isSupervisor;
      }
      const titlesMap = {
        Itineraries: "itineraries",
        Suppliers: "suppliers",
        Clients: "clients",
        Finances: "finances",
        Reports: "reports",
        Plugins: "plugins",
        Admin: "administration_panel",
        "User Access Controls": "administration_panel",
        Templates: "itineraries",
        "Group Templates": "itineraries",
        "Open Groups": "itineraries",
      };
      const actionsMap = {
        "Sales Invoices": "sales_invoices",
        "Receipts & Refunds": "receipts",
        "Purchase Invoices": "purchase_invoices",
        "Purchase Invoice Payments": "pi_payments",
        "Agents & Groups": "agent_and_groups",
        "Destinations & Pickup Points": "destinations_and_pickup_points",
        "Currencies & Taxes": "currencies_and_taxes",
        "Service Types": "service_types",
        "Departments & Rate Types": "departments_and_rate_types",
        "GT Template Importer": "gt_template_importer",
        Markups: "markups",
        Commissions: "commission",
        "Task Tracker": "task_tracker",
        "Histories List": "histories_list",
        "Supplier Contents": "supplier_contents",
        "Languages & Translations": "languages_and_translations",
        "Contents & Documents": "contents",
        "Owner Controls": "user_access_control",
        "Sage PI Approvals": "pi_payment_sage_export",
        "Export Logs": "export_logs",
        "Head Offices": "head_office",
        Routes: "routes",
        Brands: "brands",
      };

      let groupName = titlesMap[title];
      let settingName = actionsMap[actionName]
        ? actionsMap[actionName]
        : "visible";

      if (title == "Templates") {
        settingName = "templates";
      }
      if (title == "Group Templates") {
        settingName = "group_templates";
      }
      if (title == "Open Groups") {
        settingName = "open_groups";
      }
      if (actionName == "Task Settings") {
        groupName = "administration_panel";
        settingName = "task_settings";
      }
      if (title == "Agents & Groups") {
        groupName = "agents";
        settingName = "agent_and_groups";
      }
      if (actionName == "Taxes") {
        groupName = "administration_panel";
        settingName = "taxes";
      }
      if (actionName == "Departments") {
        groupName = "administration_panel";
        settingName = "departments";
      }
      if (actionName == "Rate Types") {
        groupName = "administration_panel";
        settingName = "rate_types";
      }
      if (actionName == "Currencies") {
        groupName = "administration_panel";
        settingName = "currencies";
      }
      if (actionName == "Currency Exchange Rates") {
        groupName = "administration_panel";
        settingName = "currencies";
      }
      if (actionName == "Business Models") {
        groupName = "administration_panel";
        settingName = "business_models";
      }
      if (actionName == "Routes") {
        groupName = "administration_panel";
        settingName = "routes";
      }
      if (actionName == "Brands") {
        groupName = "administration_panel";
        settingName = "brands";
      }
      if (actionName == "Internal Statuses") {
        groupName = "administration_panel";
        settingName = "internal_statuses";
      }
      if (actionName == "Nominal Codes") {
        groupName = "administration_panel";
        settingName = "nominal_codes";
      }
      if (actionName == "Charges Types" || actionName == "Mandatory Charges") {
        groupName = "administration_panel";
        settingName = "charges";
      }
      if (actionName == "Payment Types") {
        groupName = "administration_panel";
        settingName = "payment_types";
      }
      if (actionName == "Circuit Discounts") {
        groupName = "plugins";
        settingName = "circuit_discounts";
      }
      if (actionName == "PI Payments") {
        groupName = "finances";
        settingName = "pi_payments";
      }
      if (actionName == "Flights Management") {
        groupName = "plugins";
        settingName = "flights_management";
      }
      if (actionName == "Allocations") {
        groupName = "plugins";
        settingName = "allocations";
      }
      if (actionName == "Rates Importer") {
        groupName = "plugins";
        settingName = "rates_importer";
      }
      //console.log("actionname:", actionName, `${groupName}:${settingName}`);
      if (settingName == "head_office") {
        groupName = "suppliers";
        settingName = "head_office";
      }
      if (actionName == "Itinerary Documents") {
        groupName = "contents";
        settingName = "itinerary_documents";
      }
      if (actionName == "Third Party Setup") {
        groupName = "plugins";
        settingName = "third_party_setups";
      }
      if (actionName == "Access Module") {
        groupName = "plugins";
        settingName = "access_module";
      }
      if (actionName == "External Forms") {
        groupName = "plugins";
        settingName = "external_forms";
      }
      if (actionName.includes("Template Types")) {
        groupName = "itineraries";
        settingName = "template_types";
      }
      if (actionName == "Lead Sources") {
        groupName = "itineraries";
        settingName = "lead_source";
      }
      return groupName
        ? this.$store.getters.hasAccessTo(`${groupName}:${settingName}`)
        : true;
    },
    setZoom() {
      if (window.innerWidth < 1200) {
        document.body.style.zoom = "75%";
      } else {
        document.body.style.zoom = "100%";
      }
    },
    clearCache() {
      //console.log("Clearing cache");
      const cacheClearDomains = [
        "soake",
        "soarw",
        "soasa",
        "soasl",
        "soatz",
        "soazn",
        "golfandtravel.ie",
      ];
      if (cacheClearDomains.includes(this.$store.getters.userConfig.domain)) {
        apolloClient.cache.reset();
        //console.log("Cache cleared");
      }
    },
  },
  beforeCreate() {
    this.$store.dispatch("initLocalSettings");
  },
  mounted() {
    document.title = GT_APP_NAME;
    window.onresize = this.setZoom;
    const tabId = window.sessionStorage.getItem("tabId");
    if (!tabId) {
      window.sessionStorage.setItem("tabId", randomize("Aa0", 32));
    }
    //add chat for pinky

    document.onmousemove = this.resetInactivityTimer;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.clearCache();
      }
    });
  },
};
</script>

<style>
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/*
.v-radio .v-input--selection-controls__input {
  margin-right: 0px;
}*/

.v-data-table th {
  padding-top: 10px !important;
  vertical-align: top;
  /* font-weight: normal; */
  /* font-size: 15px !important; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*
.v-data-table td {
   overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
   width: 100%;
  max-width: 0;
}
*/
.app-bar {
  background: linear-gradient(to right top, #0d47a1, #1e88e5);
}
.v-dialog.v-dialog--active .draggable {
  cursor: grab;
}

.v-dialog.v-dialog--active .draggable:active {
  cursor: grabbing;
}

.bg {
  background: #f4f7fd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue